export default __webpack_public_path__ + "static/media/sence-3.cdac5482.png";